import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React, { useState, useEffect, useContext } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import axios from 'axios';
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import HomeIcon from "@mui/icons-material/Home";
import EditIcon from "@mui/icons-material/Edit";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import Person4Icon from "@mui/icons-material/Person4";
import CloseIcon from '@mui/icons-material/Close';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { ProductContext } from "../context/AppContext";
import Footer from './Common_Components/Footer';
function StartQuiz() {
  const navigate = useNavigate();
  const location = useLocation();

  // Extracting parameters from the location state
  const { categoryId, dayId, dayName, skitname, dayLen, imageURL } = location.state || {};
  console.log("imageURL: ", imageURL);
  const authToken = localStorage.getItem("AuthToken");
  const [activePage, setActivePage] = useState("Learning");
  const [questions, setQuestions] = useState([]);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [selectedAnswer, setSelectedAnswer] = useState('');
  const [showResult, setShowResult] = useState(false);
  const [correctOption, setCorrectOption] = useState('');
  const [allOptions, setAllOptions] = useState([]);
  const [skitDescription, setskitDescription] = useState([]);
  // const [incorretAnswer, setIncorretAnswer] = useState([]);
  const [incorrectAnswer, setIncorretAnswer] = useState([]);
  const [queslength, setQueslength] = useState(0);
  const [selectedLanguage, setSelectedLanguage] = useState('');
  const SelectLanguageLocal = localStorage.getItem("selectedLanguage");
  const [isLoading, setIsLoading] = useState(true);
  const { Translate } = useContext(ProductContext);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://api.japaking.online/api/skit-questions?skitCategoryId=${categoryId}&dayId=${dayId}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        if (response.data.success) {
          setQuestions(response.data.message.question);
          setQueslength(response.data.message.question.length);
        }
      } catch (err) {
        if (err.response && err.response.status === 401) {
          console.log('navigate to login due to 401');
          navigate('/Home');
        }
        console.error(err);
      }
    };
    fetchData();
  }, [categoryId, dayId, authToken, navigate]);

  const handleAnswerSelection = (answer) => {
    setSelectedAnswer(answer);
  };

  const handleSubmit = () => {
    if (selectedAnswer) {
      const currentQuestion = questions[currentQuestionIndex];

      // Get the correct option text
      const correct = currentQuestion.skit_ques.find(option => option.is_correct).option_text;
      setCorrectOption(correct);

      // Set all options (option_text and option_description)
      setAllOptions(currentQuestion.skit_ques.map(option => option.option_text));

      // Store both correct and incorrect answers with their descriptions
      setskitDescription(currentQuestion.skit_ques.map(option => ({
        option_text: option.option_text,
        option_description: option.option_description,
        is_correct: option.is_correct,
        is_selected: selectedAnswer === option.option_text, // Track selected answer
      })));

      // Check if the selected answer is incorrect and update the incorrect answers array
      if (selectedAnswer !== correct) {
        setIncorretAnswer(prev => [...prev, currentQuestion.skit_question_id]);
      }

      // Show result after submission
      setShowResult(true);
    } else {
      console.log("Please select an answer");
    }
  };

  const handleNext = () => {
    const nextQuestionIndex = currentQuestionIndex + 1;
    if (nextQuestionIndex < queslength) {
      // Move to the next question
      setCurrentQuestionIndex(nextQuestionIndex);
      setSelectedAnswer('');
      setShowResult(false);
    } else {
      // Redirect to the NextQuiz page with incorrectAnswerIds
      navigate('/next-quiz', {
        state: {
          dayId,
          categoryId,
          incorrectAnswerIds: incorrectAnswer, // Pass the incorrect answers here
          dayName,
          skitname,
          dayLen,
          imageURL,
        },
      });
    }
  };



  const currentQuestion = questions[currentQuestionIndex];

  if (!currentQuestion) {
    return <p>Loading..</p>;
  }

  return (
    <div className="StartQuiz_container d-flex flex-column" style={{ minHeight: "100vh" }}>
      {/* Header */}
      <div className="container">
        <div className="row">
          <div className="header_inner">
            <div className="container">
              <div className="row">
                <div className="col-md-12">
                  <ArrowBackIosIcon
                    onClick={() => {
                      if (showResult) {
                        setShowResult(false); // Reset the result state
                      } else {
                        navigate(-1); // Navigate back in history
                      }
                    }}
                    className="icon_1"
                  />

                  <h2>
                    {showResult
                      ? Translate?.message?.data?.quizResult || "Quiz Result"
                      : Translate?.message?.data?.startQuiz || "Start Quiz"}
                  </h2>
                  <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container-start-quiz">
        {!showResult ? (
          // Quiz Question Section
          <div className="row">
            <div className="col-md-6" style={{ borderRadius: "10px", marginTop: "20px", }}>
              <h3>{currentQuestion.question_text}</h3>
              <div>
                <img
                  src={isLoading ? `${process.env.PUBLIC_URL}/assets/images/loading.png` : currentQuestion.url}
                  onLoad={() => setIsLoading(false)}
                  onError={() => setIsLoading(false)}
                  alt="Question"
                  style={{
                    width: "80%",
                    height: "350px",
                    objectFit: "contain",
                    marginBottom: "20px",
                    marginTop: "20px",
                  }}
                />
              </div>
            </div>

            <div className="col-md-6" style={{ borderRadius: "15px" }}>
              <div className="option_container" style={{ marginTop: "50px" }}>
                <h5>{currentQuestion.question_text}</h5>
                {currentQuestion.skit_ques.map(option => {
                  const isSelected = selectedAnswer === option.option_text;
                  const backgroundColor = isSelected ? '#ffc0cb' : '#f8f9fa';

                  return (
                    <Row key={option.skit_option_id} className="mb-3">
                      <Col>
                        <button
                          className={`option-button ${isSelected ? "selected" : ""}`}
                          onClick={() => handleAnswerSelection(option.option_text)}
                          style={{
                            padding: "10px",
                            backgroundColor,
                            border: "1px solid #ccc",
                            borderRadius: "15px",
                            width: "70%",
                            cursor: "pointer",
                            color: "#000",
                            transition: "background-color 0.3s ease",
                          }}
                        >
                          {option.option_text}
                        </button>
                      </Col>
                    </Row>
                  );
                })}
                <div className="btn_container">

                  <Button style={{

                    backgroundColor: "black",

                  }}
                    onClick={handleSubmit}
                    className="btn-submit mb-1"
                  >
                    {Translate?.message?.data?.submit || "Submit"}
                  </Button>

                </div>
              </div>
            </div>
          </div>
        ) : (
          // Quiz Result Section
          <div className="row">
            <div className="col-md-6">
              <div
                className="result-box"
                style={{
                  backgroundColor: "#ffc0cb",
                  padding: "20px",
                  borderRadius: "10px",
                  height: "300px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  textAlign: "left",
                  marginLeft: "20px",
                  marginTop: "20px",
                }}
              >

                {SelectLanguageLocal === "hindi" ? (
                  <h4>{Translate?.message?.data?.question || "Question"}</h4>
                ) : (
                  <h4>Question:</h4>
                )}
                {showResult && (
                  <div className="quiz-options">
                    {allOptions.map((option, index) => (
                      <button
                        key={index}
                        className={`quiz-option ${selectedAnswer === option
                          ? showResult && option === correctOption
                            ? 'correct' // Highlight as correct if it's the correct option
                            : showResult && selectedAnswer === option && option !== correctOption
                              ? 'incorrect' // Highlight as incorrect if it's the wrong option
                              : 'selected' // Highlight as selected if chosen
                          : ''}`}
                        onClick={() => handleAnswerSelection(option)}
                        disabled={showResult && selectedAnswer !== null} // Disable options after submission
                      >
                        <span
                          className="quiz-option-text"
                          style={{
                            color: showResult
                              ? option === correctOption
                                ? 'green' // Green for the correct option
                                : selectedAnswer === option
                                  ? 'red' // Red for the incorrect selected option
                                  : 'black' // Default black for other options
                              : 'black',
                          }}
                        >
                          {option}
                        </span>

                        {/* Feedback messages */}
                        {showResult && selectedAnswer === option && (
                          <span className="quiz-option-status">
                            {option === correctOption ? (
                              <RadioButtonUncheckedIcon className="icon-correct" />
                            ) : (
                              <CloseIcon className="icon-incorrect" />
                            )}
                            {option === correctOption
                              ? (Translate?.message?.data?.correct || "Correct")
                              : (Translate?.message?.data?.incorrect || "Incorrect")}
                          </span>

                        )}
                      </button>
                    ))}
                  </div>
                )}

              </div>
            </div>

            <div className="col-md-6">
              <div
                className="result-box"
                style={{
                  backgroundColor: "#f8f9fa",
                  padding: "20px", // Keeps space between content and edges
                  borderRadius: "10px",
                  minHeight: "150px", // Ensures a minimum height even with little content
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  textAlign: "left",
                  marginLeft: "10px",
                  marginRight: "20px",
                  marginTop: "20px",
                  gap: "10px", // Adds spacing between children elements
                }}
              >

                <h4>{Translate?.message?.data?.explanation || "Explanation:"}</h4>

                {skitDescription.map((option, index) => (
                  <div key={index} style={{ marginBottom: "10px" }}>
                    <p>Option: {option.option_text}</p>  {/* Display the option text */}
                    <div>{option.option_description}</div>  {/* Display the description of the option */}
                    {/* Show if the answer was selected by the user */}
                  </div>
                ))}


              </div>
            </div>
            <div className="btn_container">
          <Button
            style={{
              backgroundColor: "black",
              width: "40%",
            }}
            onClick={handleNext}
            className="btn-submit mb-1"
          >
            {Translate?.message?.data?.next || "Next"}
          </Button>
        </div>
          </div>
        )}


        
      </div>
      <Footer />
    </div>
  );
}

export default StartQuiz;
